import { DeliveryOption } from '../../../lib/types/communication.types';
import { pluralize } from '../../../lib/helpers/text.helpers';

// Warning text shown only for the *_ONLY options, where someone lacking that
// channel is dropped; PREFERRED/BOTH guarantee delivery, so the server returns 0.
export const buildUnreachableLabel = (
  deliveryOption: DeliveryOption,
  unreachableCount: number
): string => {
  const subjectVerb = pluralize(unreachableCount, 'recipient has', 'recipients have');
  if (deliveryOption === DeliveryOption.EMAIL_ONLY) {
    return `${unreachableCount} ${subjectVerb} no email and won't receive this message`;
  }
  if (deliveryOption === DeliveryOption.SMS_ONLY) {
    return `${unreachableCount} ${subjectVerb} no phone and won't receive this message`;
  }
  return '';
};

// Footer explanation when zero messages will be delivered: name the blocked
// channel when everyone is unreachable, otherwise the audience is simply empty.
export const buildZeroMessageReason = (
  deliveryOption: DeliveryOption,
  unreachableCount: number
): string => {
  if (unreachableCount <= 0) return 'No recipients in the current audience.';
  const channel =
    deliveryOption === DeliveryOption.EMAIL_ONLY
      ? 'email'
      : deliveryOption === DeliveryOption.SMS_ONLY
        ? 'SMS'
        : 'the chosen channel';
  return `No one in this audience can be reached on ${channel} — switch the delivery option to include another channel.`;
};
